import React, { Component } from 'react';
import styled from 'styled-components';
import { grid } from './constants';
import { Draggable } from 'react-beautiful-dnd';
import type { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import QuoteList from './ItemList';
import { ColumnHeader } from "./ColumnHeader";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 80px;
  @media (min-width: 1280px) {
    width: calc(100% / ${props => props.colCount});
  }
  `;

const Container = styled.div`
  position: relative;
  width: 95% !important;
  margin: ${grid}px ${grid}px ${grid}px 0;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 4px;
  background-color: lightgray;
`;

export default class Column extends Component {
  setStyles = (provided) => {
    if (this.props.isFullScreen) {
      provided.draggableStyle.width = '165px';
    } else {
      delete provided.draggableStyle.width;
    }

    return provided.draggableStyle;
  };


  render() {
    const {title, quotes, extraFieldToShow, colCount} = this.props;
    const items = quotes !== undefined ? quotes.items : [];

    let countItems = 0;

    if (items) {
      countItems = items.length;
    }
    const listStyle = {
      marginTop: '35px',
      minWidth: '70px'
    }

    return (
      <Draggable draggableId={title} type="COLUMN">
        {(provided: DraggableProvided, snapshot: DraggableStateSnapshot) => (
          <Wrapper
            colCount={colCount}
          >
            <Container
              innerRef={provided.innerRef}
              style={this.setStyles(provided)}
            >
              <ColumnHeader snapshot={snapshot} provided={provided} countItems={countItems} title={title}/>
              <QuoteList
                style={listStyle}
                extraFieldToShow={extraFieldToShow}
                lanesList={this.props.lanesList}
                listId={title}
                listType="QUOTE"
                quotes={items}
                autoFocusQuoteId={this.props.autoFocusQuoteId}
                handlerOpenTask={this.props.handlerOpenTask}
                handlerOpenPreView={this.props.handlerOpenPreView}
                isFullScreen={this.props.isFullScreen}
              />
            </Container>
            {provided.placeholder}
          </Wrapper>
        )}

      </Draggable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Column.js